<template>
    <div class="admin-dialog h-100 w-100 overflow-auto">
        <div class="h-100 overflow-auto" style="display: block" v-if="isaDashboardsPageOpened()">
            <div class="reports_container d-flex flex-column">
                <h2 class="dark-title size-16 my-5">{{ $t('res_Label_DashboardPages') }}</h2>
                <div class="grid-4-items">
                    <!-- <v-card v-if="hasPermission('Dashboards')" @click="openDashboard()">
                        <h4 class="dark-title size-16 pb-2">{{ $t('res_TabsName_Dashboard') }}</h4>
                        <p>{{ $t('res_Label_DashboardDesc') }} </p>
                    </v-card> -->

                    <v-card v-if="hasPermission('CompletedTransfersDashboard')" @click="openAverageCompletionDashboard()" @keyup.enter="openAverageCompletionDashboard()">
                        <h4 class="dark-title size-16 pb-2">{{ $t('res_label_average_transfer_completion') }}</h4>
                        <p>{{ $t('res_Label_AverageCompletionDesc') }} </p>
                    </v-card>

                    <v-card v-if="hasPermission('DelayedTransfersDashboard')" @click="openAverageDelayDashboard()" @keyup.enter="openAverageDelayDashboard()">
                        <h4 class="dark-title size-16 pb-2">{{ $t('res_label_average_transfer_delay') }}</h4>
                        <p> {{ $t('res_Label_AverageDelayDesc') }} </p>
                    </v-card>
                    <v-card v-if="hasPermission('Delayed_Active_CorrespondenceDashboard')"
                        @click="openCorrespondenceDashboard()" @keyup.enter="openCorrespondenceDashboard()">
                        <h4 class="dark-title size-16 pb-2">{{ $t('res_TabsName_CorrespondenceDashboard') }}</h4>
                        <p> {{ $t('res_Label_CorrespondenceDashboard') }} </p>
                    </v-card>
                    <v-card v-if="hasPermission('Dashboards')"
                    @click="openUsersDashboard()" @keyup.enter="openUsersDashboard()">
                    <h4 class="dark-title size-16 pb-2">{{ $t('res_TabsName_DashboardUsers') }}</h4>
                    <p> {{ $t('res_Label_CorrespondenceDashboardUsers') }} </p>
                    </v-card>
                    <v-card v-if="hasPermission('Dashboards')"
                    @click="openDepartmentActivityDashboard()" @keyup.enter="openDepartmentActivityDashboard()">
                    <h4 class="dark-title size-16 pb-2">{{ $t('res_TabsName_DashboardDepartmentActivity') }}</h4>
                    <p> {{ $t('res_Label_DepartmeneDashboard') }} </p>
                    </v-card>
                    <v-card v-if="hasPermission('Dashboards')"
                    @click="openTypeDashboard()" @keyup.enter="openTypeDashboard()">
                    <h4 class="dark-title size-16 pb-2">{{ $t('res_TabsName_CorrespondenceTypeDashboard') }}</h4>
                    <p> {{ $t('res_Label_CorrespondenceTypeDashboard') }} </p>
                    </v-card>
                    <v-card v-if="hasPermission('Dashboards')"
                    @click="openSelectedTemplateDashboard()" @keyup.enter="openSelectedTemplateDashboard()">
                    <h4 class="dark-title size-16 pb-2">{{ $t('res_TabsName_SelectedTemplateDashboard') }}</h4>
                    <p> {{ $t('res_Label_TemplateDashboardDashboard') }} </p>
                    </v-card>
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
import router from '../router/index.js';
import constants from '../assets/js/constants';
import MessagesUtil from '@/utils/messagesUtil';

export default {
    name: 'DashboardsView',
    data: function () {
        return {
            messagesUtil: MessagesUtil,
            constants: constants
        };
    },
    mounted() {
        document.body.classList.add('hide-searchbar');
    },
    beforeDestroy() {
		document.body.classList.remove('hide-searchbar');
	},
    methods: {
        hasPermission(reportName) {
            return constants.userActions.reports.some(report => report.name == reportName);
        },
        isaDashboardsPageOpened() {
            return this.$route.name === 'dashboards';
        },
        openDashboard() {
            router.push({ name: 'dashboard' });
        },
        openAverageCompletionDashboard() {
            router.push({ name: 'average-completion-dashboard' });
        },
        openAverageDelayDashboard() {
            router.push({ name: 'average-delay-dashboard' });
        },
        openCorrespondenceDashboard() {
            router.push({ name: 'correspondence-dashboard' });
        },
        openUsersDashboard() {
            router.push({ name:'users-dashboard' });
        },
        openDepartmentActivityDashboard() {
            router.push({ name:'department-dashboard' });
        },
        openTypeDashboard() {
            router.push({ name:'type-dashboard' });
        },
        openSelectedTemplateDashboard() {
            router.push({ name:'template-dashboard' });
        }
    },
}
</script>